export class OrderByMapDto {
  key: string;
  orderBy: string;

  constructor(key: string, orderBy: string) {
    this.key = key;
    this.orderBy = orderBy;
  }
}
